import { Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";

const MUIButton = ({
  children,
  id,
  className,
  sx = {},
  fullWidth,
  color,
  textTransform,
  onClick,
  onBlur,
  onKeyDown,
  primary,
  isLoadingButton,
  isLoading,
  disabled,
  variant,
  size,
  startIcon,
  endIcon,
  type = "button",
}) => {
  const isOutlined = variant === "outlined" ? true : false;
  // Default primary styling
  const primarySx = primary
    ? {
        "&:hover": {
          background: isOutlined ? null : "rgba(252, 70, 19, 1)",
          borderColor: "rgba(252, 70, 19, 1)",
        },
        background: isOutlined ? null : "rgba(252, 70, 19, 0.9)",
        color: !isOutlined ? null : "rgba(252, 70, 19, 1)",
        borderColor: "rgba(252, 70, 19, 1)",
        borderRadius: "8px",

        "&.Mui-disabled": {
          background: isOutlined ? null : "rgba(252, 70, 19, 0.2)",
          borderColor: isOutlined ? null : "rgba(252, 70, 19, 1)",
        },
      }
    : {};

  // Default styling
  const defaultSx = {
    // borderRadius: 2,
    ...primarySx,
    textTransform: textTransform || "none",
  };

  return (
    <>
      {isLoadingButton ? (
        <LoadingButton
          id={id}
          className={className}  
          loading={isLoading}
          sx={{ ...defaultSx, ...sx }}
          color={color}
          variant={variant || "contained"}
          onClick={onClick}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          startIcon={startIcon}
          endIcon={endIcon}
          disabled={disabled}
          size={size || "medium"}
          fullWidth={!fullWidth ? fullWidth : true}
          type={type}
        >
          {children}
        </LoadingButton>
      ) : (
        <Button
          id={id}
          className={className}
          sx={{ ...defaultSx, ...sx }}
          color={color}
          variant={variant || "contained"}
          onClick={onClick}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          disabled={disabled}
          size={size || "medium"}
          startIcon={startIcon}
          endIcon={endIcon}
          fullWidth={!fullWidth ? fullWidth : true}
          type={type}
        >
          {children}
        </Button>
      )}
    </>
  );
};

export default MUIButton;
